import moment from 'moment/moment';

import { Box, Typography } from '@mui/joy';
import { Outlet } from 'react-router-dom';
import { useBrand} from '@/hooks';

import i18n from '@/i18n'

export default function AccountsLayout() {
    const { data: manager } = useBrand()

    return (
      <ws-block>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
          <Box sx={{ flex: 1 }}></Box>
          <img src={manager?.logotype_url} width="300pt" />
          <Typography level="h1" component="h1">{i18n.t(manager?.type?.replace('organization', 'distribution'))}</Typography>
          <Box style={{ flex: 1 }}></Box>
          <Outlet />
          <Box sx={{ flex: 1 }}></Box>
          <small style={{ margin: 10, opacity: 0.5 }}>Copyright &copy; {moment().format('YYYY')} {manager?.name}. All Rights Reserved.</small>
        </Box>
      </ws-block>
    )
}